import { Component, OnInit, Input } from '@angular/core';
import { LectionaryItemService, LectionaryItemSummary } from '../../services/lectionary-item.service';
import { LectionaryItemSearchFilter } from 'app/pipes/lectionary-item-search-filter.pipe';
import { LectionaryItemSearchModel } from '../lectionary-item-search/lectionary-item-search.component';

@Component({
  selector: 'app-lectionary-item-name-edit-show-items',
  templateUrl: './lectionary-item-name-edit-show-items.component.html',
  styleUrls: ['./lectionary-item-name-edit-show-items.component.css']
})
export class LectionaryItemNameEditShowItemsComponent implements OnInit {

  @Input() public lectionaryItemNameId: number;
  public entities: LectionaryItemSummary[];
  public isLoading: boolean = false;

  constructor(public lectionaryItemSvc: LectionaryItemService) { }

  ngOnInit() {
    this.getItems();
  }

  public getItems() {

    this.isLoading = true;
    var searchPayload = new LectionaryItemSearchModel();
    searchPayload.LectionaryItemNameId = this.lectionaryItemNameId;
    
    this.lectionaryItemSvc.loadEntities(searchPayload).then((s) => {
      this.entities = s;
      this.isLoading = false;
    })
    .catch((err)=> {
      alert(err);
      this.isLoading = false;
    })
  }

  public formatPageNumber(pageNumber: string) : string {
    if (pageNumber == "" || pageNumber == null) return "";
    return "p. " + pageNumber;
  }

}
